import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { BaseBusinessMemoBaseBusinessIdPutRequest } from '@/coreInfrastructureModule/axios/generated/baseBusinessManage';
import { IBaseBusinessRepository } from '@/coreInfrastructureModule/interfaces/IBaseBusinessRepository';

/**
 * 取引情報のメモを追加/修正するユースケース
 * @class PutBusinessMemoUseCase
 */
export class PutBusinessMemoUseCase {
  private repository: IBaseBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - 取引情報のリポジトリ
   */
  constructor(repository: IBaseBusinessRepository) {
    this.repository = repository;
  }

  /**
   * メモを追加/変更する
   * @param businessId - 取引ID
   * @param memoText - メモの本文
   * @returns 結果オブジェクト
   */
  async Execute(businessId: string, memoText: string): Promise<INetworkResult<string, Error>> {
    const request: BaseBusinessMemoBaseBusinessIdPutRequest = { baseBusinessMemoInfo: { memoText: memoText } };
    try {
      const result = await this.repository.putBaseBusinessMemo(businessId, request);
      switch (result.status.type) {
        case 'success':
          return {
            status: {
              type: 'success',
              data: result.status.data,
            },
          };
        case 'error':
          throw result.status.error;
        default:
          throw Error('想定外のエラー');
      }
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('想定外のエラー'),
        },
      };
    }
  }
}
